import { render } from "./InvestmentSection.vue?vue&type=template&id=a90eb8c8&scoped=true"
import script from "./InvestmentSection.vue?vue&type=script&lang=js"
export * from "./InvestmentSection.vue?vue&type=script&lang=js"

import "./InvestmentSection.vue?vue&type=style&index=0&id=a90eb8c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90eb8c8"]])

export default __exports__